import React from "react";
import "./navbar.css";

function Navbar() {
  return (
    <div className="navbar">
      <span className="bold-font">FLOATSAT</span>
      <span style={{ marginRight: "70px" }}>DATE</span>
    </div>
  );
}

export default Navbar;
